<template>
  <div id="tf-contact" class="text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <div class="section-title center">
            <h2>
              {{ $t("home.contact1") }}
              <p v-if="props.screenSize < 769">
                <strong>{{ $t("home.contact2") }}</strong>
              </p>
              <span v-else>
                <strong>{{ $t("home.contact2") }}</strong>
              </span>
            </h2>
            <div class="line">
              <hr />
            </div>
            <div class="clearfix"></div>
            <small
              ><em>{{ $t("home.question") }}</em></small
            >
          </div>

          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="exampleInputEmail1">{{ $t("home.email") }}</label>
                  <input
                    type="email"
                    class="form-control"
                    id="exampleInputEmail1"
                    :placeholder="$t('home.emailin')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="exampleInputName">{{ $t("home.name") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="exampleInputName"
                    :placeholder="$t('home.namein')"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">{{ $t("home.message") }}</label>
              <textarea class="form-control" name="message" rows="3"></textarea>
            </div>

            <button type="submit" class="btn tf-btn btn-default">
              {{ $t("home.submit") }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
  screenSize: {
    type: Number,
    default: 1920,
  },
});
</script>

<style scoped>
textarea {
  resize: none;
}
@media (max-width: 767px) {
  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 200px;
  }
  h2 {
    line-height: 50px;
  }
}
</style>
